import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewContainerRef, ChangeDetectorRef, ComponentFactoryResolver, ComponentRef, SimpleChanges, ComponentFactory } from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, componentVM } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { CyTemplateComponent } from './cy-template.component';

import { DOTextBoxComponent } from '../dotext-box/dotext-box.component';
import { DotextBoxSglComponent } from '../dotext-box-sgl/dotext-box-sgl.component';
import { DodropDownComponent } from '../dodrop-down/dodrop-down.component';
import { DotextBoxAutocompleteComponent } from '../dotext-box-autocomplete/dotext-box-autocomplete.component';
import { DoDateNgComponent } from '../do-date-ng/do-date-ng.component';
import { GridNCheckboxComponent } from '../grid-ncheckbox/grid-ncheckbox.component';
import { GridNRadioButtonComponent } from '../grid-nradiobutton/grid-nradiobutton.component';
import { GridInternalComponent } from '../grid-internal/grid-internal.component'
import { DoimageComponent } from '../doimage/doimage.component';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { DobuttonComponent } from '../dobutton/dobutton.component';
import { GridInternalAgGridComponent } from '../grid-internal-ag-grid/grid-internal-ag-grid.component';
import { DOLabelComponent } from '../dolabel/dolabel.component';
import { SectionTableDynamicComponent } from './section-table-dynamic.component';

@Component({
    selector: 'cy-template-item',
    templateUrl: './cy-template-item.component.html'
})

export class CyTemplateItemComponent implements OnInit {
    
    private _data: DOData;
    @Input() set data(doData: DOData)
    {
        this._data = doData;
        this.createComponent();
    }
    get data(): DOData
    {
        return this._data;
    }
    @Input() loaderKey: string;

    @ViewChild('container', { read: ViewContainerRef })
    private container: ViewContainerRef;

    ngOnChanges(changes: SimpleChanges) {

        if (changes['data']) {

            this.createComponent();

        }

        //let _changes: DOData = new DOData();
        //_changes = changes;
        // You can also use categoryId.previousValue and 
        // categoryId.firstChange for comparing old and new values

    }


    // Below can be returned by a service at some point
    readonly templateMapper = {
        Image: DoimageComponent,
        Label: DOLabelComponent,
        TextBox: DOTextBoxComponent,
        TextBoxWEvent: DOTextBoxComponent,
        TextBoxAutoComplete: DotextBoxAutocompleteComponent,
        TextBoxSng: DotextBoxSglComponent,
        Date: DoDateNgComponent,
        GridNCheckBox: GridNCheckboxComponent,
        GridNRadio: GridNRadioButtonComponent,
        Button: DobuttonComponent,
        DropDown: DodropDownComponent,
        DropDownWEvent: DodropDownComponent,
        Grid: GridInternalAgGridComponent,
        Grid1: GridInternalAgGridComponent,
        Grid2: GridInternalAgGridComponent
    };

    constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

    ngOnInit() {
        this.createComponent();
    }

    ngAfterViewInit()
    {
        
    }

    componentFactory: ComponentFactory<{}>;
    componentRef:ComponentRef<{}>;
    createComponent()
    {
        if (!this.componentFactory)
        {
            // Resolve the component to a component factory
            this.componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponentForTemplateType(this.data.njDocDefTemplate.tType));

            // Get a reference to the container from ng-container
            const viewContainerRef = this.container;
            viewContainerRef.clear();


            // Instantiate component and insert it the container
            this.componentRef = viewContainerRef.createComponent(this.componentFactory);
        }

        //Pass data needed to component inputs
        (<CyTemplateComponent>this.componentRef.instance).customParameters = this.data.customParameters;
        (<CyTemplateComponent>this.componentRef.instance).DocDefTemplate = this.data.njDocDefTemplate;

        if (this.data.njDocData && this.data.njDocData != null) {
            (<CyTemplateComponent>this.componentRef.instance).DocData = this.data.njDocData;
            if (this.data.njDocData.dataValue && this.data.njDocData.dataValue != null) {
                (<CyTemplateComponent>this.componentRef.instance).LookupId = this.data.njDocData.dataValue;
            }
        }
        if (this.loaderKey && this.loaderKey != null) {
            (<CyTemplateComponent>this.componentRef.instance).loaderKey = this.loaderKey;
        }
        if (this.data.isValid) {
            (<CyTemplateComponent>this.componentRef.instance).isValid = this.data.isValid;
        }
        if (this.data.isEnabled) {
            (<CyTemplateComponent>this.componentRef.instance).isEnabled = this.data.isEnabled;
        }
        if (this.data.lstDocDefTemplateLookup && this.data.lstDocDefTemplateLookup != null) {
            (<CyTemplateComponent>this.componentRef.instance).lstDocDefTemplateLookup = this.data.lstDocDefTemplateLookup;
        }
        if (this.data.lstChildDocDefTemplate && this.data.lstChildDocDefTemplate != null) {
            (<CyTemplateComponent>this.componentRef.instance).lstChildDocDefTemplate = this.data.lstChildDocDefTemplate;
        }
        if (this.data.lstDocData && this.data.lstDocData != null) {
            (<CyTemplateComponent>this.componentRef.instance).lstDocData = this.data.lstDocData;
        }
        if (this.data.customParameters.hasEvent) {
            this.SubscribeToPrimEventEmitter(this.componentRef);
        }
        this.componentRef.changeDetectorRef.detectChanges();
    }


    private SubscribeToPrimEventEmitter(componentRef: ComponentRef<{}>)
    {
        switch (this.data.njDocDefTemplate.tType)
        {
            case "Image":
                break;
            case "Label":
                break;
            case "TextBox":
                this.TextBox(componentRef);
                break;
            case "TextBoxWEvent":
            case "TextBoxAutoComplete":
                this.TextBoxAutoComplete(componentRef);
                break;
            case "TextBoxSng":
                this.TextBoxSingleLine(componentRef);
                break;
            case "Date":
                this.DODate(componentRef);
                break;
            case "GridNCheckBox":
                this.gridNCheckBox(componentRef);
                break;
            case "GridNRadio":
                this.gridNRadioButton(componentRef);
                break;
            case "Button":
                this.DOButton(componentRef);
                break;
            case "DropDown":
            case "DropDownWEvent":
                this.DODropDown(componentRef);
                break;
            case "Grid":
            case "Grid1":
            case "Grid2":
                this.AGGrid(componentRef);
                break;
        }
    }

    AGGrid(componentRef: ComponentRef<{}>)
    {
        (<GridInternalAgGridComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
        (<GridInternalAgGridComponent>componentRef.instance).doubleClick.subscribe((event) => {
            this.EmitEvent("doubleClick", event);
        });
        (<GridInternalAgGridComponent>componentRef.instance).requestRows.subscribe((event) => {
            this.EmitEvent("requestRows", event);
        });
    }

    DODropDown(componentRef: ComponentRef<{}>)
    {
        (<DodropDownComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
    }

    DOButton(componentRef: ComponentRef<{}>)
    {
       
        (<DobuttonComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
        (<DobuttonComponent>componentRef.instance).tabEvent.subscribe((event) => {
            this.EmitEvent("tabEvent", event);
        });
    }

    DODate(componentRef: ComponentRef<{}>)
    {
        (<DoDateNgComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
    }

    TextBox(componentRef: ComponentRef<{}>)
    {
        (<DOTextBoxComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
        (<DOTextBoxComponent>componentRef.instance).tabEvent.subscribe((event) => {
            this.EmitEvent("tabEvent", event);
        });
        (<DOTextBoxComponent>componentRef.instance).tbDblClick.subscribe((event) => {
            this.EmitEvent("tbDblClick", event);
        });
    }

    TextBoxAutoComplete(componentRef: ComponentRef<{}>)
    {
        (<DotextBoxAutocompleteComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
    }

    TextBoxSingleLine(componentRef: ComponentRef<{}>)
    {
        (<DotextBoxSglComponent>componentRef.instance).clickBut.subscribe((event) => {
            this.EmitEvent("clickBut", event);
        });
        //(<DotextBoxSglComponent>componentRef.instance).DocData.subscribe(data => this.prop = data);
    }

    private gridNRadioButton(componentRef: ComponentRef<{}>)
    {
        if ((<GridNRadioButtonComponent>componentRef.instance).clickRadio != null)
        {
            (<GridNRadioButtonComponent>componentRef.instance).clickRadio.subscribe((event) => {
                this.EmitEvent("clickRadio", event);
            });
        }
    }

    private gridNCheckBox(componentRef: ComponentRef<{}>) {
        if ((<GridNCheckboxComponent>componentRef.instance).clickChkbox != null)
        {
            (<GridNCheckboxComponent>componentRef.instance).clickChkbox.subscribe((event) => {
                this.EmitEvent("clickChkbox", event);
            });
        }
    }


    @Output() EventToEmit: EventEmitter<EventEmitterWrapper> =
        new EventEmitter<EventEmitterWrapper>();

    EmitEvent(action:string, event:any)
    {
        let _event: EventEmitterWrapper = { EventType: action, DataEmitted: event };
        this.EventToEmit.emit(_event);
    }

    // Determine the current component to load
    private getComponentForTemplateType(tType) {
        return this.templateMapper[tType];
    }

    public ngOnDestroy()
    {

        if (this.componentFactory) {

            this.componentFactory = null;

        }

        if (this.componentRef) {

            this.componentRef.destroy();

        }

    }
}


export class EventEmitterWrapper
{
    constructor() { }
    EventType: string;
    DataEmitted: any;
}